// Named constants replace magic integers 0/1 for activeToolBar state.
// Using string values as the canonical identifiers.
export const GALLERY_TABS = {
	PHOTOS: 'photos',
	VIDEO: 'video'
};
